import React, { useState } from "react";
import { useKycStore } from "../../stores/useKycStore";
import Checkbox from "../../components/shared/Checkbox";
import { InfoCircledIcon } from "@radix-ui/react-icons";

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: React.ReactNode;
  className?: string;
}

export default function SumSubConsentView() {
  const [checked1, setChecked1] = useState(false);
  const { setAcceptedTerms } = useKycStore();

  return (
    <div className="flex flex-col gap-6 w-full pt-4">
      <p className="text-[#CBCED1] font-['Neue Montreal'] text-[18px] font-medium leading-[22.5px]">
        Provide consent to proceed
      </p>
      <div className="flex flex-col gap-1 w-full">
        <Checkbox
          checked={checked1}
          onChange={setChecked1}
          label={"I accept E-Sign consent"}
          className="rounded-t-md"
        />
      </div>
      <div className="flex gap-2">
        <span>
          <InfoCircledIcon
            color="#CBCED1"
            style={{ width: "20px", height: "20px" }}
          />
        </span>
        <p className="text-[#CBCED1] font-['Neue Montreal'] text-[15.75px] font-medium leading-[22.5px]">
          BrahmaFi card is not affiliated with swype.fun , AAVE, Euler or other
          Defi and issued subject to separate terms provided by Issuer.
        </p>
      </div>
      <button
        className={`flex h-[44px] justify-center items-center gap-1 self-stretch rounded-lg bg-white backdrop-blur-[6px] text-black font-medium text-[16px] transition ease-in-out ${
          checked1
            ? "cursor-pointer opacity-100"
            : "cursor-not-allowed opacity-50"
        }`}
        disabled={!checked1}
        onClick={() => setAcceptedTerms(true)}
      >
        Continue to Sumsub Verification
      </button>
      <div className="flex gap-2">
        <span>
          <InfoCircledIcon
            color="#CBCED1"
            style={{ width: "20px", height: "20px" }}
          />
        </span>

        <p className="text-[#CBCED1] font-['Neue Montreal'] text-[15.75px] font-medium leading-[22.5px]">
          Brahma never stores your data we use Sumsub that completes the
          verification process to ensure safety
        </p>
      </div>
    </div>
  );
}
